import useIdentifyForEasyCardPin from '@activities/easyCard/common/hooks/useIdentifyForEasyCardPin';
import Lock from '@icons/Lock';

interface Props {
    pinRegistered: boolean;
}

function UpdatePinButton({ pinRegistered }:Props) {
    const { handleIdentity } = useIdentifyForEasyCardPin();
    if (!pinRegistered) {
        return null;
    }
    return (
        <Lock onClick={handleIdentity}/>
    );
}

export default UpdatePinButton;
